// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1UHBX","info":"Note_info__2v-9c","note":"Note_note__3zPDw","actions":"Note_actions__2lEQV"};